var _path, _circle, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 13.8906C0 6.40026 6.07214 0.328125 13.5625 0.328125C21.0529 0.328125 27.125 6.40026 27.125 13.8906C27.125 21.381 21.0529 27.4531 13.5625 27.4531C6.07214 27.4531 0 21.381 0 13.8906Z",
    fill: "#FFD456"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5652,
    cy: 10.8806,
    r: 2.97538,
    stroke: "#356733",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.84571 17.9943C8.84491 17.7852 8.89169 17.5786 8.98251 17.3901C9.26751 16.8201 10.0712 16.5181 10.7381 16.3813C11.2191 16.2786 11.7067 16.21 12.1973 16.1761C13.1056 16.0963 14.0192 16.0963 14.9276 16.1761C15.4181 16.2104 15.9057 16.279 16.3868 16.3813C17.0536 16.5181 17.8573 16.7916 18.1423 17.3901C18.325 17.7742 18.325 18.2201 18.1423 18.6042C17.8573 19.2027 17.0536 19.4763 16.3868 19.6074C15.9064 19.7143 15.4186 19.7848 14.9276 19.8183C14.1882 19.881 13.4455 19.8924 12.7046 19.8525C12.5336 19.8525 12.3683 19.8525 12.1973 19.8183C11.7081 19.7852 11.2222 19.7147 10.7438 19.6074C10.0712 19.4763 9.27321 19.2027 8.98251 18.6042C8.89216 18.4136 8.84542 18.2053 8.84571 17.9943Z",
    stroke: "#356733",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUsers);
export default __webpack_public_path__ + "static/media/iconUsers.e9f5611ec5af5a09b124601c4f10f2aa.svg";
export { ForwardRef as ReactComponent };